export default __webpack_public_path__ + "static/media/portfolio-192.c059c26f.jpg";